import { IconButton, Input } from 'components';
import { TYPE_CHECKBOX } from 'components/Form/Input';
import { ArrayHelperActionWrapper, BasicTextField, EditableItem, FullViewSubBlock } from 'components/FullView';
import { Add, Delete } from 'components/icons';
import { ArrayHelpers, Field, FieldProps, FormikErrors, FormikTouched } from 'formik';
import { newDomain } from 'modules/organization/constants';
import { CTIData, Domain } from 'modules/organization/types/organizationDetail/cti';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  domain: Domain;
  index: number;
  errors: FormikErrors<CTIData>;
  touched: FormikTouched<CTIData>;
  arrayHelpers: ArrayHelpers;
};

const EditDomain: React.FunctionComponent<Props> = ({ domain, index, errors, touched, arrayHelpers }: Props) => {
  const { t } = useTranslation(['organization', 'global']);

  const addDomain = React.useCallback(() => arrayHelpers.push(newDomain), [arrayHelpers]);
  const removeDomain = React.useCallback(() => arrayHelpers.remove(index), [arrayHelpers, index]);

  return (
    <FullViewSubBlock>
      <h3 className="sub-title">{domain.domainName || t('detail.labels.domainPlaceholder')}</h3>
      <ArrayHelperActionWrapper>
        <BasicTextField
          name={`domains.${index}.domainName`}
          label={t('detail.labels.name')}
          errors={errors}
          touched={touched}
          autoFocus={!domain.domainId}
        />
        {index === 0 && (
          <IconButton onClick={addDomain} tooltip={t('tooltips.addDomain')}>
            <Add />
          </IconButton>
        )}
        <IconButton onClick={removeDomain} tooltip={t('tooltips.removeDomain')}>
          <Delete />
        </IconButton>
      </ArrayHelperActionWrapper>
      <BasicTextField
        name={`domains.${index}.fullyQualifiedDomainName`}
        label={t('detail.labels.fullyQualifiedDomainName')}
        errors={errors}
        touched={touched}
      />
      <BasicTextField
        name={`domains.${index}.registrar`}
        label={t('detail.labels.registrar')}
        errors={errors}
        touched={touched}
      />
      <BasicTextField
        name={`domains.${index}.hostingCompany`}
        label={t('detail.labels.hostingCompany')}
        errors={errors}
        touched={touched}
      />
      <BasicTextField
        name={`domains.${index}.emailAbuse`}
        label={t('detail.labels.emailAbuse')}
        errors={errors}
        touched={touched}
      />
      <EditableItem
        label={t('organization:detail.labels.isExcludedFromAlerting')}
        value={
          <Field name={`domains.${index}.isExcludedFromAlerting`}>
            {({ field }: FieldProps<any>) => (
              <Input
                {...field}
                type={TYPE_CHECKBOX}
                defaultChecked={field.value}
                label={field.value ? t('global:yes') : t('global:no')}
              />
            )}
          </Field>
        }
      />
    </FullViewSubBlock>
  );
};

export default EditDomain;
